import { List } from 'immutable';

import { contextMenuState } from './contextMenus';
import { modalState } from './modals';
import { viewState } from './view';

import { exportModule } from './module';

export const ComponentLibraryModule = exportModule({
  state: List([contextMenuState, modalState, viewState]) as any
});
